<script>
    export let show_top_border = true;
</script>

<div class="topfootercontainer
maincontainer {(false) ? "topborder" : ""}">
    <div class="leftfootercontainer">
        <div class="lflogocontainer"><img src="/img/semper elevate_dark.svg" alt="HomeEasy log"></div>
        <!-- <div class="appstorebadgecontainer">
            <div class="iosbadgecontainer">
                <a href="https://apps.apple.com/us/app/homeeasy-mortgage/id1543249109"><img src="/img/app_store_badge_grey.jpg" alt="App Store"></a>
            </div>
            <div class="googlebadgecontainer">
                <a href="https://play.google.com/store/apps/details?id=com.simplenexus.loans.client.s__111612"><img src="/img/play_store_badge_grey.jpg" alt="Play Store App"></a>
            </div>
        </div> -->
    </div>

    <div class="middlefootercontainer">

        <div class="linkscontainer">
            <div class="linklistcontainer">
              <div class="lltitle">Company</div>
              <div class="link">
                <a href="https://asksemper.zendesk.com/hc/en-us">Resources</a>
              </div>
              <div class="link">
                <a href="tel:866-528-3814">(866) 528-3814</a>
              </div>
              <div class="link">
                <a href="https://homeeasy.semperhl.com/login">Sign in</a>
              </div>
            </div>
            <div class="linklistcontainer">
              <div class="lltitle">Legal</div>
              <div class="link">
                <a href="https://semperhomeloans.com/terms/">Terms</a>
              </div>
              <div class="link">
                <a href="https://semperhomeloans.com/privacy/">Privacy</a>
              </div>
              <div class="link">
                <a href="https://semperhomeloans.com/disclaimers-disclosures/"
                  >Disclaimers & Disclosures
                </a>
              </div>
              <div class="link">
                <a href="https://semperhomeloans.com/assumptions/"
                  >Assumptions</a
                >
              </div>
              <div class="link">
                <a href="/homeeasy/index.html"
                  >Process</a
                >
              </div>
            </div>
          </div>


    </div>

    <div class="rightfootercontainer">
        <div class="sociallinkscontainer">
            <div class="sociallink"><a href="https://twitter.com/SemperHL"
            ><i class="fab fa-twitter" aria-hidden="true"></i
          ></a></div>
          <div class="sociallink"><a href="https://www.facebook.com/semperhl"
            ><i class="fab fa-facebook-f" aria-hidden="true"></i
          ></a></div>
            <div class="sociallink"><a href="https://www.instagram.com/semperhl/"
            ><i class="fab fa-instagram" aria-hidden="true"></i
          ></a></div>
          <div class="sociallink"><a href="https://www.linkedin.com/company/semper-home-loans"
            ><i class="fab fa-linkedin-in" aria-hidden="true"></i
          ></a></div>

        </div>
    </div>

</div>

<div class="disclaimercontainer maincontainer {(false) ? "topborder" : ""}">


    
    
    
    
    <!-- <p>We don’t yet have your complete financial picture. Your actual rate, payment and costs could be higher.</p>  -->
    
    <!-- <p>Standard text & data messaging rates apply. Text HELP for help. Text STOP to stop.</p> -->

    <!-- <p>2021 Semper Home Loans, Inc.</p>  -->
    
    <!-- <p>Home lending products offered by Semper Home Loans, Inc. Semper Home Loans is a direct lender. <a href="https://nmlsconsumeraccess.org/EntityDetails.aspx/COMPANY/1053" target="_blank">NMLS #1053</a>. 225 Dupont Drive, Providence, RI 02907. Loans made or arranged pursuant to a California Finance Lenders law License. Not available in all states. Equal Housing Lender. (NMLS Consumer Access Link) All rights reserved.</p> -->

    <div class="clinecontainer">
        <div class="ehllogocontainer"><img src="img/equal_housing_logo_grey.png" alt="Equal Housing Lender"></div>
        <div class="ehllogocontainer"><img src="img/Better_business_logo-01.png" alt="BBB Accredited"></div>

        <!-- <div class="ehltextcontainer">Equal Housing Lender</div> -->
    
    </div>

    <p>&copy; 2010-2021 Semper Home Loans Inc. NMLS #1053 <a href="https://nmlsconsumeraccess.org/EntityDetails.aspx/COMPANY/1053" target="_blank">www.nmlsconsumeraccess.com</a></p>    
    <p>Semper Home Loans is an Equal Opportunity Employer. Semper Home Loans does not discriminat on the basis of race, religion, color, sex, gender identity, sexual orientation, age, non-disqualifying physical or mental disability, national origin, veteran status or any other basis covered by appropriate law. All employment is decided on the basis of qualifications, merit, and business need.</p>

    <p>Licensed in the following states: AL CA CO CT DE DC FL GA IN IA LA ME MD MA MI MT NE NJ NH NM NY NC ND OK OR PA RI SC SD TN TX VA WA WY</p>

    <p>Rates are subject to change at any time and without notice. To ensure you have the latest rates, we update them in real-time.</p>

    <p>Interest rates and APRs are for informational purposes and do not include all applicable fees. Your actual rate, payment, and costs may differ.</p>

    <p>Semper Home Loans does not charge an origination fee. The one-time cost shown include points/credits and third-party fees. An escrow deposit, pre-paid interest and other charged may be required depending on your situation.</p>

    <p>Monthly payments do not include taxes and insurance premiums. Your actual monthly housing expenses will be higher.</p>


</div>

<style>
a, a:visited, a:hover, a:active {
  color: inherit;
  text-decoration: underline;
}    
.maincontainer {
    width: 100%;
    padding-top: 0px;
    padding-bottom: 50px;
    text-align: left;
    font-weight: normal;
    font-size: 16px;
    /* color: #a5a5a5; */
    color: #727272;
    margin-top: 15px;
}
.disclaimercontainer {
    font-size: 12px;
}
.topborder {
    border-top: solid 1px;
    border-color: #a5a5a5;
}
.clinecontainer {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}
.ehllogocontainer {
    /* display: inline-block; */
    height: 32px;
    margin-right: 20px;
}
.ehllogocontainer img {
    height: 100%;
}
.ehltextcontainer{
    /* display: inline-block; */
    /* margin-left: 24px; */
    border-right: 1px solid #a5a5a5;
    padding-right: 10px;
}
.copyrighttextcontainer{
    margin-left: 10px;
}
.topfootercontainer {
    display: flex;
    align-items: flex-start;
    width: 100%;
    justify-content: space-between;
    margin-top: 100px;
}
.leftfootercontainer {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
.lflogocontainer {
    height: 48px;
}
.lflogocontainer img {
    height: 100%;
}
.appstorebadgecontainer {
    display: flex;
    align-items: center;
    margin-top: 32px;
}
.iosbadgecontainer, .googlebadgecontainer {
    height: 32px;
}
.iosbadgecontainer img, .googlebadgecontainer img {
    height: 100%;
}
.googlebadgecontainer {
    margin-left: 20px;
}
.linkscontainer {
    display: flex;
}
.linklistcontainer:first-of-type {
    margin-right: 80px;
}
.lltitle {
    font-weight: 600;
    margin-bottom: 20px;
}
.link{
    margin-bottom: 10px;
}
.link a, .link a:hover, .link a:active{
    text-decoration: none;
}
.sociallinkscontainer {
    display: flex;
    justify-content: flex-end;
    width: 200px;
}
.sociallink a {
    /* color: #ebebec; */
    text-decoration: none;
    margin-left: 20px;
    font-size: 24px;
}

@media (max-device-width: 1200px), (max-width: 1199px) {
    .maincontainer {
        border-top: none;
    }
    .clinecontainer {
        flex-direction: row;
        flex-wrap: wrap;
    }
    .copyrighttextcontainer {
        width: 100%;
    }
    .ehltextcontainer {
        margin-left: 0px;
        border: none;
        padding-right: 0px;
        margin-bottom: 10px;
        margin-top: 10px;
    }
    .topfootercontainer {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
        justify-content: flex-start;
    }
    .rightfootercontainer, .leftfootercontainer, .middlefootercontainer {
        width: 100%;
    }
    .lflogocontainer {
        width: 100%;
        height: 48px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    .appstorebadgecontainer {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 40px;
    }
    .iosbadgecontainer, .googlebadgecontainer {
        margin: 0px;
        padding: 0px;
        box-sizing: border-box;
    }
    .iosbadgecontainer {
        height: 54px;
    }
    .googlebadgecontainer {
        height: 48px;
    }
    .iosbadgecontainer img, .googlebadgecontainer img {
        height: 100%;
    }
    .iosbadgecontainer {
        margin-left: 0px;
    }
    .googlebadgecontainer {
        margin-left: 0px;
        margin-top: 20px;
    }

    .linkscontainer {
        width: 100%;
        display: flex;
        flex-direction: column;
        margin-top: 40px;
        align-items: flex-start;
    }
    .linklistcontainer {
        width: 100%;
    }
    .linklistcontainer:first-of-type {
        margin-right: 0px;
    }
    .lltitle {
        font-weight: 800;
        font-size: 20px;
        margin-bottom: 20px;
        margin-top: 40px;
        text-align: left;
    }
    .link{
        margin-bottom: 20px;
        text-align: left;
    }
    .sociallinkscontainer {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-top: 40px;
    }
    .sociallink a {
        /* color: #ebebec; */
        text-decoration: none;
        margin-left: 20px;
        font-size: 36px;
        font-family: "Font Awesome 5 Brands";
        font-weight: 600;
    }
    .sociallink a i {
        font-weight: 600;
        font-family: "Font Awesome 5 Brands";
    }

}
</style>